var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSystem = function SvgSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14.07 16.56a4.357 4.357 0 1 0 0-8.714 4.357 4.357 0 0 0 0 8.714M14.07 23.407v3.858M14.07 31a1.867 1.867 0 1 0 0-3.734 1.867 1.867 0 0 0 0 3.734M23.641 28.226l-3.97-2.205v-5.175M4.499 28.226l3.97-2.205v-5.175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M25.274 14.07v-3.734l-2.195-.548a9.3 9.3 0 0 0-.929-2.248l1.163-1.938-2.64-2.64-1.939 1.162a9.3 9.3 0 0 0-2.248-.93L15.938 1h-3.735l-.548 2.194a9.3 9.3 0 0 0-2.248.93L7.469 2.96l-2.64 2.64L5.99 7.54a9.3 9.3 0 0 0-.93 2.248l-2.194.548v3.734l2.194.55c.214.796.526 1.55.93 2.247l-1.163 1.938 2.64 2.64 1.939-1.162a9.3 9.3 0 0 0 2.248.93l.548 2.194h3.735l.548-2.195a9.3 9.3 0 0 0 2.248-.93l1.938 1.164 2.64-2.641-1.162-1.938a9.3 9.3 0 0 0 .93-2.248zM25.274 31a1.867 1.867 0 1 0 0-3.734 1.867 1.867 0 0 0 0 3.734M2.867 31a1.867 1.867 0 1 0 0-3.734 1.867 1.867 0 0 0 0 3.734"
  })));
};
export default SvgSystem;